import { render, staticRenderFns } from "./ManageCustomerContact.vue?vue&type=template&id=1fb6db42&scoped=true"
import script from "./ManageCustomerContact.vue?vue&type=script&lang=js"
export * from "./ManageCustomerContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb6db42",
  null
  
)

export default component.exports